import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { getConnection, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { QueriesService } from 'src/app/core/services/queries.service';
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';
import { GenerarPdfDetalleCuotasService } from '../services/generar-pdf-detalle-cuotas.service';
import { GenerarPdfEstadoCuentaService } from '../services/generar-pdf-estado-cuenta.service';
import { GenerarPdfHistorialPagosService } from '../services/generar-pdf-historial-pagos.service';
import { ReporteCartera } from '../services/detalle-reporte.service';

@Component({
  selector: 'app-historial-pagos-detallados',
  templateUrl: './historial-pagos-detallados.component.html',
  styleUrls: ['./historial-pagos-detallados.component.scss']
})
export class HistorialPagosDetalladosComponent implements OnInit {

  STEP = 1;

  listaCliente: any[] = []
  listaClienteSeleccionados: any[] = []

  defaultColumns: CokyTableColumn[] = [
    { title: "No. Ide", name: "n_ide" },
    { title: "Nombre", name: "nombre" },
    { title: "Cuenta", name: "cue" },
    { title: "Factura", name: "factura" },
  ]

  public form = this.formBuilder.group({
    n_ide: ["", [Validators.required]],
    cue: ["", [Validators.required]],
  })

  public formTipo = this.formBuilder.group({
    tipo: ["hist-pagos-det", [Validators.required]],
  })

  constructor(private formBuilder: FormBuilder,
    private queriesService: QueriesService,
    private notificationHelper: NotificationHelper,
    private generarPdf: GenerarPdfHistorialPagosService,
    private generarPdfDetalleCuota: GenerarPdfDetalleCuotasService,
    private generarPdfEstadoCuenta: GenerarPdfEstadoCuentaService,
    private ReporteCarteraPDF: ReporteCartera,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  get esConexionJP(): boolean {
    return String(getConnection() || '').toUpperCase() === 'JP';
  }

  async buscar() {
    this.STEP = 1;
    const formValues = this.form.value;
    if (!this.form.get("n_ide")?.valid) { 
      return this.notificationHelper.warningMessage("Ingrese el No. de identificación"); 
    }
    if (!this.form.get("cue")?.valid) { 
      return this.notificationHelper.warningMessage("Ingrese el No. de cuenta"); 
    }
    let cedula = formValues.n_ide;
    let cuenta = formValues.cue;
    showSpinner("Buscando");
    const result = await this.ReporteCarteraPDF.detalleCartera(await getConnection(), cedula, cuenta);
    hideSpinner();
    if (result.success) {
      if (!result.data || result.data.length === 0) {
        this.notificationHelper.warningMessage("Cuenta con saldo 0 o cancelada");
        return;
      }
      this.listaCliente = result.data;
      this.STEP = 2;
      this.moverScroll('step2');
    } else {
      this.notificationHelper.errorMessage(result.message);
    }
  }

  async clienteSeleccionado(e) {
    this.listaClienteSeleccionados = e;
    this.STEP = 3;
    this.moverScroll('step3');
  }

  async descargar() {
    const formValues = this.formTipo.value
    if (!this.formTipo.get("tipo")?.valid) { return this.notificationHelper.warningMessage("Debe seleccionar un tipo de historico") }
    if (formValues.tipo === 'est-cuenta' && !this.esConexionJP) {
      this.formTipo.get("tipo")?.setValue("hist-pagos-det");
      return this.notificationHelper.warningMessage("Estado de cuenta solo esta disponible para JP");
    }
    switch (formValues.tipo) {
      case 'hist-pagos-det':
        await this.genHistoricoPagoDet();
        break;
      case 'det-cuotas':
        await this.genDetCuotas();
        break;
      case 'est-cuenta':
        await this.genEstadoCuenta();
        break;
    }
  }

  async genDetCuotas() {
    showSpinner("Generando documento")
    const n_ide = this.listaClienteSeleccionados[0].N_IDE;
    const cuenta = this.listaClienteSeleccionados[0].CUE;
    const factura = this.listaClienteSeleccionados[0].FACTURA;

    let enc: any;
    let det: any[];

    try {
      const resEnc = await this.ReporteCarteraPDF.DetalleCuota(await getConnection(),n_ide, factura,cuenta);

      if (!resEnc.success) {
        this.notificationHelper.errorMessage(resEnc.error);
        hideSpinner();
        return;
      }
      enc = resEnc.data[0];
      enc.factura = factura
      let agencia = enc.AGENCIA;
      let tipo_credito = enc.TIPO_CREDITO;

      const resDet = await this.ReporteCarteraPDF.ResDetalleCuota(await getConnection(),cuenta, factura,agencia,tipo_credito);
      if (!resDet.success) {
        this.notificationHelper.errorMessage(resDet.error);
        hideSpinner();
        return;
      }
      if (!resDet.data || resDet.data.length === 0) {
        this.notificationHelper.warningMessage("Factura sin detalle disponible");
        hideSpinner();
        return;
      }
      det = resDet.data;
      hideSpinner();

    } catch (error) {
      this.notificationHelper.errorMessage(String(error));
      hideSpinner();
      return;
    }

    await this.generarPdfDetalleCuota.generar(enc, det);

  }
  async genEstadoCuenta() {
    showSpinner("Generando documento")
    const n_ide = this.listaClienteSeleccionados[0].N_IDE;
    const cuenta = this.listaClienteSeleccionados[0].CUE;
    const factura = this.listaClienteSeleccionados[0].FACTURA;

    let data:{
      n_ide: string,
      cuenta: string,
      factura: string
    } = {
      n_ide,
      cuenta,
      factura
    }
    let estadoCuenta: any;

    try {
      const resEnc = await this.ReporteCarteraPDF.ResResumenCuenta(await getConnection(),data);

      if (!resEnc.success) {
        this.notificationHelper.errorMessage(resEnc.error);
        hideSpinner();
        return;
      }

      estadoCuenta = Array.isArray(resEnc.data) ? resEnc.data[0] : resEnc.data;

      if (!estadoCuenta || !estadoCuenta.Encabezado) {
        this.notificationHelper.warningMessage("Factura sin resumen de cuenta disponible");
        hideSpinner();
        return;
      }

      estadoCuenta.factura = factura;
      estadoCuenta.cuenta = cuenta;

    } catch (error) {
      this.notificationHelper.errorMessage(String(error));
      hideSpinner();
      return;
    }

    await this.generarPdfEstadoCuenta.generar(estadoCuenta);
    hideSpinner();

  }

  async genHistoricoPagoDet() {
    if (this.listaClienteSeleccionados.length == 0) {
      return this.notificationHelper.warningMessage("Debe seleccionar una factura");
    }
    showSpinner("Generando documento")
    let n_ide = this.listaClienteSeleccionados[0].N_IDE;
    let factura = this.listaClienteSeleccionados[0].FACTURA;
    const result = await this.ReporteCarteraPDF.HistoricaePagoDet(await getConnection(),n_ide, factura);
    hideSpinner()
    if (result.success) {
      if (!result.data || result.data.length === 0) {
      this.notificationHelper.warningMessage("Factura sin pagos");
      return;
      }
      result.data = result.data.map(n => {
      return {
        ...n,
        CAPITAL: '$' + new Intl.NumberFormat().format(Number(n.CAPITAL)),
        GASTOS_COBRANZA: '$' + new Intl.NumberFormat().format(Number(n.GASTOS_COBRANZA)),
        HONORARIOS: '$' + new Intl.NumberFormat().format(Number(n.HONORARIOS)),
        INTERES: '$' + new Intl.NumberFormat().format(Number(n.INTERES)),
        INTERES_MORA: '$' + new Intl.NumberFormat().format(Number(n.INTERES_MORA)),
        SEGURO_FINANCIERO: '$' + new Intl.NumberFormat().format(Number(n.SEGURO_FINANCIERO)),
        CUOTA_MANEJO: isNaN(Number(n.CUOTA_MANEJO)) ? '$0' : '$' + new Intl.NumberFormat().format(Number(n.CUOTA_MANEJO)),
        INTERES_MES_GRACIA: isNaN(Number(n.VALOR_MGRACIA)) ? '$0' : '$' + new Intl.NumberFormat().format(Number(n.VALOR_MGRACIA)),
        VALOR_FULL: '$' + new Intl.NumberFormat().format(Number(n.VALOR_FULL)),
        FECHA: this.datePipe.transform(n.FECHA, 'dd-MM-yyyy', '+0000'),
        FACTURA: n.FACTURA,
        FUENTE_MGRACIA: n.FUENTE_MGRACIA,
        RECIBO: n.RECIBO,
      };
      });
      this.generarPdf.generar(this.listaClienteSeleccionados[0], result.data);

    } else {
      this.notificationHelper.errorMessage(result.message)
    }
  }

  async moverScroll(tag: string) {
    setTimeout(function () {
      const docu = document.getElementById(tag);
      if (docu) {
        docu.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    }, 200);
  }

}
